import store from '../../../../store';
export default function checkIfCanDestroy() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('system_roles_destroy_company') || scopes.includes('system_roles_destroy_all')) {
    exists = true;
  }
  return exists;
}
